import { getCookie, setCookie } from './cookieUtils'

export const GCLID_COOKIE = 'sfb_gclid'
export const FBCLID_COOKIE = 'sfb_fbclid'

const CLICK_ID_MAX_AGE_SECONDS = 90 * 24 * 60 * 60

const SAFE_CLICK_ID = /^[A-Za-z0-9_\-/.]+$/

function sanitizeClickId(value: string | null): string | null {
  if (!value) return null
  const trimmed = value.trim()
  if (!trimmed || !SAFE_CLICK_ID.test(trimmed)) return null
  return trimmed
}

/**
 * Capture gclid/fbclid from the current URL into first-party cookies (90 days).
 * Only writes when the query param is present — never clears an existing cookie.
 */
export function captureClickIdsFromUrl(): void {
  if (typeof window === 'undefined') return

  const params = new URLSearchParams(window.location.search)
  const gclid = sanitizeClickId(params.get('gclid'))
  const fbclid = sanitizeClickId(params.get('fbclid'))

  if (gclid) {
    setCookie(GCLID_COOKIE, gclid, { maxAge: CLICK_ID_MAX_AGE_SECONDS })
  }
  if (fbclid) {
    setCookie(FBCLID_COOKIE, fbclid, { maxAge: CLICK_ID_MAX_AGE_SECONDS })
  }
}

export function getStoredGclid(): string | null {
  return sanitizeClickId(getCookie(GCLID_COOKIE))
}

export function getStoredFbclid(): string | null {
  return sanitizeClickId(getCookie(FBCLID_COOKIE))
}
